import { useState } from 'react';
import { cn } from '@/lib/cn';

interface LogoPlateProps {
  src: string;
  /** Short uppercase stand-in shown when the image cannot load. */
  monogram: string;
  /** Sizing (width, height, padding, monogram size) is the caller's; the plate has none. */
  className?: string;
}

/**
 * A logo on a white plate. Several of the supplied PNGs are opaque white, so the plate is what
 * makes them all read alike on the dark surface; used by the coverage cards and the coin
 * chips at very different sizes. Decorative: the name is always written beside it.
 */
export function LogoPlate({ src, monogram, className }: LogoPlateProps) {
  const [failed, setFailed] = useState(false);

  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden bg-white font-extrabold text-background',
        className,
      )}
    >
      {failed ? (
        monogram
      ) : (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          draggable={false}
          onError={() => setFailed(true)}
          className="h-full w-full select-none object-contain"
        />
      )}
    </span>
  );
}
